import React from "react";
import { useNavigate } from "react-router-dom";
import "./Page404.css";
export default function Page404() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <div className="page-404-container">
      <div className="page-404-content">
        <h1 className="page-404-title">404</h1>
        <h2 className="page-404-subtitle">Oops! Page Not Found</h2>
        <p className="page-404-text">
          We're sorry, the page you're looking for doesn't exist or may have
          been moved.
        </p>
        <button className="page-404-button" onClick={handleGoHome}>
          Go to Homepage
        </button>
      </div>
    </div>
  );
}
